// Module
var code = "<div id=\"page-title\"> <h4 class=\"title\"> Changelog </h4> </div> <div id=\"page-content\" class=\"scroll-y\"> <div id=\"changelog-container\" class=\"m-4 p-4 card rounded d-flex flex-column\"> </div> </div>";
// Exports
export default code;